import {useEffect, useState} from 'react';
import {RELATIVE_TIME_REFRESH_MS} from '@FormMakerReact/layout/form-maker-header/form-maker-header.types';

export function useRelativeTimeTick(): void {
  const [, setTick] = useState<number>(0);
  useEffect(() => {
    const id = window.setInterval(() => {
      setTick((prev) => prev + 1);
    }, RELATIVE_TIME_REFRESH_MS);
    return (): void => {
      window.clearInterval(id);
    };
  }, []);
}
